import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './GradePicker.scss';

class GradePicker extends Component {
  constructor() {
    super();
    this.state = {
      grades: [
        {
          slug: 'playground',
          label: (
            <span>
              <small>Pre-K &amp;</small>K
            </span>
          ),
          link: '/pre-k-and-k-playground',
        },
        { slug: '1', label: '1', link: '/grade/1' },
        { slug: '2', label: '2', link: '/grade/2' },
        { slug: '3', label: '3', link: '/grade/3' },
        { slug: '4', label: '4', link: '/grade/4' },
        { slug: '5', label: '5', link: '/grade/5' },
        { slug: '6', label: '6', link: '/grade/6' },
        { slug: '7', label: '7', link: '/grade/7' },
        { slug: '8', label: '8', link: '/grade/8' },
      ],
    };
  }

  render() {
    return (
      <header className="GradePicker">
        <div className="GradePicker__content">
          <ul className="GradePicker__list">
            <li className="GradePicker__item GradePicker__item--label">
              Browse by Grade
            </li>
            {this.state.grades.map((grade, i) => {
              return (
                <li
                  className={
                    'GradePicker__item GradePicker__item--' + grade.slug
                  }
                  key={'grade-' + grade.slug}
                >
                  <Link to={grade.link} className="GradePicker__link">
                    {grade.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </header>
    );
  }
}

export default GradePicker;
